export default __webpack_public_path__ + "static/media/AM.c49f95ef.svg";